


















import { Component, Prop, Vue } from "vue-property-decorator";
import { SlottedSelectItem } from "@/components/VSlottedSelect.vue";

@Component
export default class MediumSelectorItem extends Vue {
  @Prop({ required: true }) readonly item!: SlottedSelectItem;
  @Prop({ default: false }) readonly hasChevron!: boolean;
}
